import _ from 'lodash';

/**
 * Reports whether an ECG study was recorded at the high sampling rate. Requires a non-empty ECG detail object whose samplingRate equals 1000.
 *
 * @param ecgDetail - ECG detail object carrying the study sampling rate.
 * @returns True when the ECG detail declares a 1000 Hz sampling rate.
 */
const checkUsingHighSamplingRateStudy = (ecgDetail: any) =>
  !_.isEmpty(ecgDetail) && ecgDetail.samplingRate === 1000;

export { checkUsingHighSamplingRateStudy };
